import { Avatar } from '@/components/ui/Avatar'

export interface Reader {
  userId: string
  name: string
  mxc: string | null
}

// Presentational: renders avatars of people who've read up to this message.
// Placement (which message a reader's marker belongs on) is computed in Timeline,
// since a read receipt can point at a non-rendered event (reaction, redaction, …).
// Clicking opens the full message-info / read-by view.
export function ReadReceipts({ readers, onClick }: { readers: Reader[]; onClick?: () => void }) {
  if (readers.length === 0) return null

  const shown = readers.slice(0, 4)
  const extra = readers.length - shown.length

  return (
    <button
      onClick={onClick}
      className="receipts hover:opacity-80 transition-opacity"
      title={`Seen by ${readers.map((r) => r.name).join(', ')} — click for details`}
    >
      {shown.map((r, i) => (
        <span
          key={r.userId}
          className="inline-flex rounded-full"
          style={{ marginLeft: i ? -5 : 0, zIndex: shown.length - i, boxShadow: '0 0 0 2px rgb(var(--np-surface))' }}
        >
          <Avatar mxc={r.mxc} name={r.name} userId={r.userId} size={15} />
        </span>
      ))}
      {extra > 0 && <span className="ml-1 text-[9px] font-data text-[rgb(var(--np-tx-muted))]">+{extra}</span>}
    </button>
  )
}
